export const toDayFormat = (dateString) => {
    /**
        * Takes date input with format : YYYY-MM-DD and transforms it to DD-MM-YYYY
        */
    let parts = dateString.split("-");

    const newDateFormat = parts[2] + "-" + parts[1] + "-" + parts[0];

    return newDateFormat;
};

export const convertMonthsToYears = (months) => {
    return months / 12;
};

export const extract = (dateTime, type) => {
    const part = dateTime.find(p => p.type === type);
    return part ? part.value : '';
};

export const toLocaleDate = (date, language = 'fr-CA') => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };

    const formatter = new Intl.DateTimeFormat(language, options);
    const parts = formatter.formatToParts(date);

    const year = extract(parts, 'year');
    const month = extract(parts, 'month');
    const day = extract(parts, 'day');
    const hour = extract(parts, 'hour');
    const minute = extract(parts, 'minute');
    const second = extract(parts, 'second');
    const formatedDateTime = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

    return formatedDateTime;
};



// WEBPACK FOOTER //
// ./src/components/common/dateHelper.js